// ABOUTME: Where a custom page was opened from, for widgets that act on the originating product.
// ABOUTME: Provided by the catalog PDP dialog (the card's prototype, a configurator opener, the embedded flag, a back action); empty elsewhere.

import { createContext, useContext } from 'react';

export interface CustomPageOrigin {
    /** Prototype of the catalog card the page was opened from. */
    prototypeId?: string;
    /** Opens the configurator outside the page's container (e.g. closing the dialog first). */
    openConfigurator?: (prototypeId: string) => void;
    /**
     * The page is shown inside another view (e.g. a dialog) rather than as a route: navigating back
     * to the page's list would leave that view, so widgets hide their back navigation.
     */
    embedded?: boolean;
    /**
     * The back action of an embedded page (e.g. closing the dialog it sits in). Widgets show their
     * back button with it in place of the navigation to the page's list; without it they hide it.
     */
    onBack?: () => void;
}

export const CustomPageOriginContext = createContext<CustomPageOrigin>({});

export const useCustomPageOrigin = () => useContext(CustomPageOriginContext);
